var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailDark = function SvgEmailDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14017_34246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26465 18.9295C1.3789 20.2026 2.37286 21.1572 3.6478 21.2486C5.33115 21.3695 8.0611 21.5 12 21.5C15.9389 21.5 18.6688 21.3695 20.3522 21.2486C21.6271 21.1572 22.6211 20.2027 22.7353 18.9295C22.8672 17.4602 23 15.1888 23 12C23 8.8112 22.8672 6.53985 22.7353 5.0705C22.6211 3.79737 21.6271 2.84285 20.3522 2.75133C18.6688 2.63051 15.9389 2.5 12 2.5C8.0611 2.5 5.33115 2.63051 3.6478 2.75133C2.37286 2.84284 1.3789 3.79737 1.26465 5.0705C1.13279 6.53985 1 8.8112 1 12C1 15.1888 1.13279 17.4602 1.26465 18.9295Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8273 11.2123C22.5401 10.888 22.9879 10.1702 22.968 9.3874C22.9208 7.52705 22.8278 6.1014 22.7353 5.0705C22.621 3.79738 21.6271 2.84285 20.3521 2.75134C18.6688 2.63051 15.9389 2.5 11.9999 2.5C8.06105 2.5 5.3311 2.63051 3.64777 2.75133C2.37283 2.84285 1.37887 3.79737 1.26462 5.0705C1.1721 6.1014 1.07913 7.52705 1.03189 9.3874C1.01201 10.1702 1.45983 10.888 2.17257 11.2123C4.97445 12.4873 9.7536 14.5 11.9999 14.5C14.2463 14.5 19.0254 12.4873 21.8273 11.2123Z",
    fill: "#0F172A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14017_34246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
};
export default SvgEmailDark;